// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Empty_wrapper__3qFrx","title":"Empty_title__1NOwn","subtitle":"Empty_subtitle__3LTHx"};